import React, {useEffect, useState} from 'react';
import { Modal, } from 'antd';
import axios from '../Common/axios';
import InfoTableCorrective from './InfoTableCorrective';
import {correctiveColumnData} from './columns';
import {postSaveVaCorrectiveData, getFindInfoCorrectiveListData } from '../Common/api';

function InfoCorrective({reportId, reportInfo, assetType}) {

    const [companyCode, setCompanyCode] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDataChange, setIsDataChange] = useState(false);
    const titleName="조치방안 등록";

    useEffect(() => {
        //자동조회
        if(reportId) {
            findInfoListData();
        }
    }, []);

    useEffect(() => {
        if(reportInfo) {
            setCompanyCode(reportInfo.com_cd);
        }
    }, [reportInfo]);

    // 정보 변경시 재조회
    useEffect(() => {
        if(isDataChange) {
            findInfoListData();
        }
    }, [isDataChange]);

    const findInfoListData = () => {
        // 보고서ID 필수조건 체크
        if (reportId == '') {
            Modal.info({title:titleName, content:"Report ID가 누락되었습니다."});
            return;
        }

        setIsLoading(true);
        setIsDataChange(false);
        
        const url = getFindInfoCorrectiveListData(reportId);
        
        axios.get(url)
            .then((response) => {
                setIsLoading(false);
                
                // response.data가 배열인 경우와 data 속성을 가진 객체인 경우를 모두 처리
                const data = response.data.data || response.data || [];
                setDataSource(data);
            })
            .catch((error) => {
                setIsLoading(false);
                Modal.error({title:titleName, content: error.response?.data?.message || error.message || "데이터 조회 실패", okText:"Close"});
            });
    };

    // 저장 클릭 시
    const onClickSaveHandler = (saveData) => {
        // 변경건이 있으면 추가
        if(saveData.length > 0) {
            saveCheckList(saveData);
        } else {
            Modal.info({title:titleName, content:"변경된 데이타가 없습니다.", okText:"Close"});
        }
    }

    // 등록/수정/삭제 API
    const saveCheckList = (saveData) => {

        setIsDataChange(false);
        axios.post(postSaveVaCorrectiveData()
                        , {reportId : reportId, saveData : saveData}
                        , {logCompany : companyCode, logParam : reportId})
        .then((response) => {
            if(response.data.status == 'success') {
                Modal.info({title:titleName, content: response.data.message, okText:"Close", onOk() {
                    // Modal이 닫힌 후 재조회
                    findInfoListData();
                }});
            } else {
                Modal.info({title:titleName, content: response.data, okText:"Close"});  
            }
        })
        .catch((error) => {
            Modal.error({title:titleName, content: error.response?.data?.message || error.message || "저장 실패", okText:"Close"});
        });
    };

    // 팝업에서 업로드 후 재조회
    const onReloadHandler = () => {
        //재조회
        findInfoListData();
    }
    /** -------------------------------------------------------------------------- **/
    return (
        <>
            <div className='tab_content'>
                <InfoTableCorrective
                    data={dataSource} 
                    columnData={correctiveColumnData}
                    reportId={reportId}
                    reportInfo={reportInfo}
                    infoType={'corrective'}
                    isLoading={isLoading} 
                    onClickSaveHandler={onClickSaveHandler}
                    onReloadHandler={onReloadHandler}
                    assetTypeOrg={assetType}
                    rowIndex={(record,index) => `${record.id}-${record.unique_id ?? index}`}
                />
            </div>
        </>
    );
}

export default InfoCorrective;